import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const getInvoiceDetails = (state) => {
  return axios.get(API + "billing/invoice-details/"+state+"/",{headers: authHeader(),});
};
const getInvoiceLineDetails = (state) => {
    return axios.get(API + "billing/invoiceLine-details/"+state+"/",{headers: authHeader(),});
  };
const DetailsInvoiceService = {
    getInvoiceDetails,
    getInvoiceLineDetails
  };
  export default DetailsInvoiceService;